module.exports = __webpack_public_path__ + "img/ig.f37d01ee.svg";